import { render } from "./MinutasAdmin.vue?vue&type=template&id=8a3e5cc8&scoped=true"
import script from "./MinutasAdmin.vue?vue&type=script&lang=js"
export * from "./MinutasAdmin.vue?vue&type=script&lang=js"

import "./MinutasAdmin.vue?vue&type=style&index=0&id=8a3e5cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a3e5cc8"]])

export default __exports__